import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import './BarcodeScanner.css';

const BARCODE_FORMATS = [
  Html5QrcodeSupportedFormats.EAN_13,
  Html5QrcodeSupportedFormats.EAN_8,
  Html5QrcodeSupportedFormats.UPC_A,
  Html5QrcodeSupportedFormats.UPC_E,
  Html5QrcodeSupportedFormats.CODE_39,
  Html5QrcodeSupportedFormats.CODE_93,
  Html5QrcodeSupportedFormats.CODE_128,
  Html5QrcodeSupportedFormats.ITF,
  Html5QrcodeSupportedFormats.CODABAR
];

const BarcodeScanner = ({ onScan, onClose }) => {
  const [error, setError] = useState(null);
  const [starting, setStarting] = useState(true);
  const scannerRef = useRef(null);
  const html5QrRef = useRef(null);

  useEffect(() => {
    const elementId = 'barcode-scanner-container';
    const config = {
      fps: 10,
      qrbox: { width: 250, height: 120 },
      formatsToSupport: BARCODE_FORMATS
    };

    const startScanner = async () => {
      try {
        const html5Qr = new Html5Qrcode(elementId, {
          formatsToSupport: BARCODE_FORMATS
        });
        html5QrRef.current = html5Qr;

        await html5Qr.start(
          { facingMode: 'environment' },
          config,
          (decodedText) => {
            if (decodedText && decodedText.trim()) {
              html5Qr.stop().catch(() => {});
              onScan(decodedText.trim());
            }
          },
          () => {}
        );
        setError(null);
      } catch (err) {
        setError(err.message || 'Camera niet beschikbaar');
        console.error('Barcode scanner error:', err);
      } finally {
        setStarting(false);
      }
    };

    startScanner();
    return () => {
      if (html5QrRef.current?.isScanning) {
        html5QrRef.current.stop().catch(() => {});
      }
    };
  }, [onScan]);

  return (
    <div className="barcode-scanner-overlay">
      <div className="barcode-scanner">
        <h3>Scan barcode</h3>
        <div id="barcode-scanner-container" className="barcode-scanner-video" />
        {error && <p className="barcode-scanner-error">{error}</p>}
        {starting && !error && <p className="barcode-scanner-status">Camera starten...</p>}
        <button type="button" className="barcode-scanner-close" onClick={onClose}>
          Sluiten
        </button>
      </div>
    </div>
  );
};

export default BarcodeScanner;
